import { defineComponent } from '@vue/composition-api';
import { CommonFileTypeIcon } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '5rem',
    },
    _increment: { name: 'ลำดับ', width: '4rem' },
    _computedIcon: {
      name: '',
      width: '2.75rem',
      component: defineComponent({
        render(createElement: any) {
          return createElement(
            CommonFileTypeIcon,
            // eslint-disable-next-line
            { attrs: { filename: (this as any).row.item.file_path } },
          );
        },
        props: { row: {} },
      }),
    },
    // eslint-disable-next-line
    'file_name': {
      name: 'ชื่อไฟล์',
      width: '2fr',
    },
    _secondaryControls: {
      width: '4rem',
    },
  },
  columns: ['_primaryControls', '_increment', 'file_name', '_secondaryControls'],
  sortable: ['file_name'],
  // search: {
  //   for: 'ไฟล์',
  //   column: 'name',
  // },
};
